import { gql } from "@apollo/client";

export default gql`
  query preferred($first: Int, $last: Int, $after: String, $before: String, $employerId: String) {
    preferred(first: $first, last: $last, after: $after, before: $before, employerId: $employerId) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          workerId
          employerId
          type
          isNotified
          notifyAfter
          notifyAfterUtc
          reason
          createdAt
          createdAtUtc
          worker {
            id
            firstName
            lastName
            fullName
            email
            phone
            rating
            noShowCount
            grossPay
            profileImageUrl
            signedProfileImageUrl
          }
          employer {
            id
            companyName
          }
        }
      }
    }
  }
`;
